import { FeaturedEvents } from "@/components/FeaturedEvents";
export const FeaturedSection = () => {
  return <section id="featured-events" className="py-12 md:py-20 bg-black px-4">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 md:mb-12 text-center">Upcoming Events</h2>
        <FeaturedEvents />
      </div>
    </section>;
};